export const options = {
    "status": 0,
    "description": "List fetched successfully",
    "timestamp": 13541156436,
    "dynamic_field_options": {
        "EB": "European Bank",
        "CHB": "China Bank"
    }
}
